import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'adminConsole.userUnlocking.title',
    defaultMessage: 'Sblocca utenza',
    description: 'Title of user unlocking dialog',
  },
  text: {
    id: 'adminConsole.userUnlocking.text',
    defaultMessage: 'Procedere con lo sblocco dell’utenza?',
    description: 'Content of user unlocking dialog',
  },
});
